// extracted by mini-css-extract-plugin
export default {"table":"Table_table__q-lvJ","table__name":"Table_table__name__X7w7Z","table__list":"Table_table__list__vmbMp"};